import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";

export const Page404 = () => {
  const location = useLocation();

  return (
    <div>
      <h1>🎯 404</h1>
      <Box>Page not found:</Box>
      <Box sx={{ fontSize: "0.8rem" }} component="code">
        {location.pathname}
      </Box>
    </div>
  );
};
